const initialState = {
  fetching: false,
};

export default function taskTemplateReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'TASK_TEMPLATE_ADDING':
      return { ...currentState, fetching: true };
    case 'TASK_TEMPLATE_ADDED':
      return { ...currentState, fetching: false };
    case 'TASK_TEMPLATE_FETCHING':
      return { ...currentState, fetching: true };
    case 'TASK_TEMPLATE_PAGE_FETCHING':
      return { ...currentState, fetching: true };
    case 'TASK_TEMPLATE_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    case 'TASK_TEMPLATE_PAGE_FETCHED':
      return { ...currentState, page: action.payload.data, fetching: false };
    case 'TASK_TEMPLATE_DELETING':
      return { ...currentState, fetching: true };
    case 'TASK_TEMPLATE_DELETED':
      return { ...currentState, fetching: false };
    default:
      return currentState;
  }
}
